
export enum CruiseControlType {
  No= 'No',
  Standard= 'Standard',
  Adaptive= 'Adaptive',

}